/* eslint-disable no-unused-vars */
/* Title: profiles Actions
 * Description: profile progress,operations related actions here.
 * Author: Majeed
 * Date: 2021-09-30
 */

import { FETCH_PROFILE_DATA, PROFILE_LOADING } from './profileActionTypes';
import { profileOverview } from '../../../api/ENDPOINTS/overview';
import { fetchData } from '../../../api/GET/fetchData';
import { getRequest } from '../../../utils/requests';

/* Fetching Profile Data
ACTION: 
1. Initial Product Data Fetching
2. Fetch Again if any Query ParameterChanges

Payload: 
1. Response Data
2. Total Product Page (from Header)
*/

export function fetchProfileData() {
    return async function fetchProfileDataThunkFunc(dispatch) {
        dispatch({
            type: PROFILE_LOADING,
            payload: true,
        });
        const response = await getRequest('/v1/vendor-dashboard/profile');

        dispatch({
            type: FETCH_PROFILE_DATA,
            payload: response.data,
        });
        dispatch({
            type: PROFILE_LOADING,
            payload: false,
        });
    };
}

export const fetchProfileCompletePercent = () => async (dispatch) => {
    // goes here
    console.log(dispatch);
};
